var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecision({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "_x33_0",
    enableBackground: "new 0 0 64 64",
    height: "512px",
    viewBox: "0 0 64 64",
    width: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m53 35v-1c0-1.654-1.346-3-3-3s-3 1.346-3 3v4.343c0 1.336.521 2.592 1.465 3.536l.535.535v4.586h-12.22l-.659-2.635c2.865-1.219 4.879-4.061 4.879-7.365v-10c0-1.103-.897-2-2-2h-9c-3.859 0-7 3.14-7 7v5c0 3.304 2.014 6.146 4.878 7.365l-.658 2.635h-2.22c-5.514 0-10 4.486-10 10v6h28v-7.068l7.499-.536c3.646-.261 6.501-3.328 6.501-6.983v-9.413c0-2.206-1.794-4-4-4zm-21 18.464-3.826-4.464h7.653zm-7-16.464v-5c0-2.757 2.243-5 5-5h9v10c0 1.771-.776 3.36-2 4.46v-4.46h-2v5.65c-.627.222-1.298.35-2 .35v-4h-2v4c-.702 0-1.373-.128-2-.35v-5.65h-2v4.46c-1.224-1.1-2-2.689-2-4.46zm4.805 7.901c.391.059.788.099 1.195.099h2c.407 0 .804-.04 1.195-.099l.525 2.099h-5.44zm-12.805 12.099c0-4.411 3.589-8 8-8h.541l5.459 6.369v5.631h-8v-6h-2v6h-4zm38-8.587c0 2.61-2.04 4.802-4.644 4.988l-9.356.667v6.932h-8v-5.631l5.459-6.369h10.541c1.103 0 2-.897 2-2v-4h4zm0-7.413h-4.586l-.535-.535c-.566-.567-.879-1.32-.879-2.122v-4.343c0-.552.448-1 1-1s1 .448 1 1v3h2c1.103 0 2 .897 2 2z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31 21h2v-12h4.868l-5.868-8.803-5.868 8.803h4.868zm1-17.197 2.132 3.197h-4.264z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 29c.552 0 1 .449 1 1v15h2v-15c0-1.654-1.346-3-3-3h-9v-4.869l-8.803 5.869 8.803 5.868v-4.868zm-11 1.131-3.197-2.131 3.197-2.131z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 15h7c.552 0 1 .449 1 1v7h2v-7c0-1.654-1.346-3-3-3h-7v-4.869l-8.803 5.869 8.803 5.869zm-2 1.131-3.197-2.131 3.197-2.131z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.803 28-8.803-5.869v4.869h-9c-1.654 0-3 1.346-3 3v15h2v-15c0-.551.448-1 1-1h9v4.868zm-6.803-2.131 3.197 2.131-3.197 2.131z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41 16c0-.551.448-1 1-1h7v4.869l8.803-5.869-8.803-5.869v4.869h-7c-1.654 0-3 1.346-3 3v7h2zm10-4.131 3.197 2.131-3.197 2.131z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF6600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecision);
export default __webpack_public_path__ + "static/media/decision.bba61986c1d452703e45c72f12e2e1b9.svg";
export { ForwardRef as ReactComponent };